import { BrowserRouter, Route, Routes } from "react-router-dom";
import './App.css';
import Evaluacion from './components/Evaluacion';
import Error404 from './components/Error404';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
            <Route path="*" element={
              <Error404 />
            } />
            <Route path="/:tecnico/:ticket/:tipo_servicio/:id_sql" element={
              <Evaluacion />
            } />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
